"use strict";

/**
 *
 * Initializes and handles the availabilitycaliendar.
 *
 */

const $ = require("jquery");
const axios = require("axios");
const dataSourceAvailability = require("./source-booking-availability");
const { dataTransformToYearKeys } = require("./transform-booking-availability");
const formStatus = require("./../booking-form-status/booking-form-status");

require("bootstrap-year-calendar");
require("./../../../../node_modules/bootstrap-year-calendar/css/bootstrap-year-calendar.min.css");

// In order to add a translation, `require` the translation file here.
require("./bootstrap-year-calendar.de");
// ---

let calendarItems = {};
const statusClass = "js-availability-form-status-global";

/**
 *
 * Gets the data.
 *
 */
function fetchDates() {
  const items = dataSourceAvailability.getItems(dataTransformToYearKeys);
  return items;
}

/**
 *
 * Retreives the language.
 *
 */
function getLanguage() {
  // NOTE: in case of inconsistent language naming, add the maping logic here.
  const language = $("#calendar").attr("data-language");
  return language;
}

/**
 *
 * Sets the color of that date at the calendar.
 *
 * @param {object} element The html element of the date.
 * @param {object} date The Date object of the date.
 *
 */
function customizeDate(element, date) {
  if (date.getDate() == 1 && date.getMonth() == 0) {
    trivialyRemovePastYears();
  }

  const year = date.getFullYear();
  if (calendarItems[year]) {
    const currentDateObject = calendarItems[year].find(function(item) {
      return (
        date.getMonth() == item.date.getMonth() &&
        date.getDate() == item.date.getDate()
      );
    });

    if (currentDateObject) {
      $(element).attr("data-available", currentDateObject.available);
      $(element).attr("data-editable", currentDateObject.editable);
    }

    if (currentDateObject && currentDateObject.tooltip) {
      $(element).attr("data-placement", "top");
      $(element).attr("data-toggle", "tootltip");
      $(element).attr("title", currentDateObject.tooltip);
      $(element).tooltip();
    }

    $($(element).parent()).addClass("availability-calendar__day");

    if (currentDateObject && currentDateObject.color) {
      $($(element).parent()).addClass(
        "availability-calendar__day--" + currentDateObject.color
      );
    }

    if (
      !currentDateObject ||
      (currentDateObject && currentDateObject.editable !== 1)
    ) {
      $($(element).parent()).addClass("disabled");
    }
  } else {
    $($(element).parent()).addClass("disabled");
  }
}

/**
 *
 * Set the onclick function of the calendar.
 *
 * @param {object} event The click event of the date click.
 *
 */
function onDateClick(event) {
  const element = event.element;
  const isEditable =
    $($(element).find(".day-content")).attr("data-editable") === "1";

  if (!isEditable) {
    return;
  }

  if ($(element).hasClass("availability-calendar__day--loading")) {
    return;
  } else {
    $(element).addClass("availability-calendar__day--loading");
    try {
      const date = event.date;
      const isAvailable =
        $($(element).find(".day-content")).attr("data-available") === "1";
      const newState = !isAvailable;
      updateDate(date, newState, element);
    } catch (e) {
      $(element).removeClass("availability-calendar__day--loading");
    }
  }
}

/**
 *
 * Initializes the bootstrap calendar
 *
 */
function bootstrapCalendar() {
  calendarItems = fetchDates();

  $("#calendar").calendar({
    enableRangeSelection: false,
    startYear: new Date().getFullYear(),
    language: getLanguage(),
    customDayRenderer: customizeDate,
    clickDay: onDateClick
  });
}

function updateDate(date, newState, element) {
  const day = ("0" + date.getDate()).slice(-2);
  const month = ("0" + (date.getMonth() + 1)).slice(-2);
  const year = date.getFullYear();

  const dateString = `${year}-${month}-${day}`;
  const key = `dates[${dateString}][available]`;

  const token = $('meta[name="csrf-token"]').attr("content");
  const url = $("#calendar").attr("data-route");
  const available = newState ? 1 : "";

  const formData = new FormData();
  formData.append("_token", token);
  formData.append("_method", "PUT");
  formData.append(key, available);

  const headers = {
    "Content-Type": "multipart/form-data",
    Accept: "application/json",
    cache: false
  };

  axios
    .post(url, formData, {
      headers
    })
    .then(function() {
      $($(element).find(".day-content")).attr("data-available", available);
      const newClasses = ["day", "availability-calendar__day"];

      if (newState) {
        newClasses.push("availability-calendar__day--green");
      } else {
        newClasses.push("availability-calendar__day--red");
      }

      $(element).attr("class", newClasses.join(" "));
    })
    .catch(function(err) {
      let errorMessage = err.response.data.message;
      formStatus.clearStatus(statusClass);
      formStatus.showError(statusClass, errorMessage);
      $(element).removeClass("availability-calendar__day--loading");
    });
}

/**
 *
 * Hides the old years
 *
 */
function trivialyRemovePastYears() {
  const monthsToShow = 24;

  const date = new Date();
  const currentYear = date.getFullYear();
  const curentMonth = date.getMonth();

  const lastDate = new Date();
  lastDate.setMonth(monthsToShow + curentMonth);
  const lastYear = lastDate.getFullYear();

  $(".year-title").each(function(i, item) {
    const year = Number($(item).text());
    const shouldShow = year >= currentYear && year <= lastYear;

    !shouldShow && $(item).css({ display: "none" });
  });
}

const onLoad = () => {
  $(".js-availability-weel-submit").on("click", function() {
    $(".js-availability-week-form").submit();
  });

  bootstrapCalendar();
};

module.exports = {
  onLoad
};



// WEBPACK FOOTER //
// ./resources/js/libraries/booking-availability-calendar/booking-availability-calendar.js